export const getAuxTimerSeconds = (
  timerList: Array<number | boolean | string | null | undefined> | undefined,
  slot: number,
): number => {
  const rawValue = timerList?.[slot];
  if (typeof rawValue === 'number') return Math.max(0, rawValue);
  if (typeof rawValue === 'boolean') return rawValue ? 1 : 0;
  if (typeof rawValue === 'string') {
    const parsed = Number.parseInt(rawValue, 10);
    return Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
  }
  return 0;
};

export const formatAuxTimerDuration = (seconds: number, useHourMinuteMode = false): string => {
  const safeSeconds = Math.max(0, seconds);
  if (safeSeconds <= 0) return 'Off';
  if (useHourMinuteMode) {
    const totalMinutes = Math.floor(safeSeconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  }
  const minutes = Math.floor(safeSeconds / 60);
  const remainSeconds = safeSeconds % 60;
  if (minutes <= 0) return `${remainSeconds}s`;
  if (remainSeconds <= 0) return `${minutes}m`;
  return `${minutes}m ${remainSeconds}s`;
};

export const formatAuxTimerCountdown = (seconds: number, useHourMinuteMode = false): string => {
  return `will turn off in ${formatAuxTimerDuration(seconds, useHourMinuteMode)}`;
};
